var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "quantity-buttons-wrapper no-highlight",
      class: _vm.customType,
      attrs: { role: "group", "aria-labelledby": _vm.ariaId }
    },
    [
      _c(
        "div",
        {
          staticClass: "button--quantity",
          attrs: {
            tabindex: "0",
            "aria-label": "decrease " + _vm.itemName + " quantity",
            id: _vm.ariaId + "-dec",
            role: "button"
          },
          on: {
            keydown: function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.decrement($event)
            },
            click: _vm.decrement
          }
        },
        [
          _c("BaseIcon", {
            class: { icon: true },
            attrs: { icon: "minusIcon", size: "lg" }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("input", {
        ref: "quantityField",
        staticClass: "quantity text-input",
        attrs: {
          pattern: "\\d{1,3}",
          id: _vm.ariaId,
          "aria-label": _vm.itemName + " quantity",
          "aria-live": "polite",
          "aria-relevant": "text",
          "aria-controls": _vm.ariaId + "-dec " + _vm.ariaId + "-inc"
        },
        domProps: { value: _vm.quantity },
        on: { input: _vm.handleInput, focus: _vm.handleFocus }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "button--quantity",
          attrs: {
            tabindex: "0",
            "aria-label": "increase " + _vm.itemName + " quantity",
            id: _vm.ariaId + "-inc",
            role: "button"
          },
          on: {
            keydown: function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.increment($event)
            },
            click: _vm.increment
          }
        },
        [
          _c("BaseIcon", {
            class: { icon: true },
            attrs: { icon: "plusIcon", size: "lg" }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b7d0169e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b7d0169e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/BaseQuantityButtons.vue
// module id = null
// module chunks = 